import type { CardDef } from '../types/cards';
import { copies, cost, produce, produceOne, science, shields, vp, coins } from './helpers';

/** Era I (2ª edición): 49 cartas. Las manos pasan a la IZQUIERDA. */
export const AGE1_CARDS: CardDef[] = [
  // Marrones
  { id: 'lumber_yard', color: 'brown', cost: cost(''), effects: [produce('W')], copies: copies(1, 3, 4) },
  { id: 'stone_pit', color: 'brown', cost: cost(''), effects: [produce('S')], copies: copies(1, 3, 5) },
  { id: 'clay_pool', color: 'brown', cost: cost(''), effects: [produce('C')], copies: copies(1, 3, 5) },
  { id: 'ore_vein', color: 'brown', cost: cost(''), effects: [produce('O')], copies: copies(1, 3, 4) },
  { id: 'tree_farm', color: 'brown', cost: cost('1$'), effects: [produceOne('WC')], copies: copies(1, 6) },
  { id: 'excavation', color: 'brown', cost: cost('1$'), effects: [produceOne('SC')], copies: copies(1, 4) },
  { id: 'clay_pit', color: 'brown', cost: cost('1$'), effects: [produceOne('CO')], copies: copies(1, 3) },
  { id: 'timber_yard', color: 'brown', cost: cost('1$'), effects: [produceOne('WS')], copies: copies(1, 3) },
  { id: 'forest_cave', color: 'brown', cost: cost('1$'), effects: [produceOne('WO')], copies: copies(1, 5) },
  { id: 'mine', color: 'brown', cost: cost('1$'), effects: [produceOne('SO')], copies: copies(1, 6) },
  // Grises (también existen en la Era II con el mismo nombre)
  { id: 'loom', color: 'grey', cost: cost(''), effects: [produce('L')], copies: [...copies(1, 3, 6), ...copies(2, 3, 5)] },
  { id: 'glassworks', color: 'grey', cost: cost(''), effects: [produce('G')], copies: [...copies(1, 3, 6), ...copies(2, 3, 5)] },
  { id: 'press', color: 'grey', cost: cost(''), effects: [produce('P')], copies: [...copies(1, 3, 6), ...copies(2, 3, 5)] },
  // Azules
  { id: 'altar', color: 'blue', cost: cost(''), effects: [vp(3)], copies: copies(1, 3, 5) },
  { id: 'theater', color: 'blue', cost: cost(''), effects: [vp(3)], copies: copies(1, 3, 6) },
  { id: 'well', color: 'blue', cost: cost(''), effects: [vp(3)], copies: copies(1, 4, 7) },
  { id: 'baths', color: 'blue', cost: cost('S'), effects: [vp(3)], copies: copies(1, 3, 7) },
  // Amarillas
  { id: 'tavern', color: 'yellow', cost: cost(''), effects: [coins(5)], copies: copies(1, 4, 5, 7) },
  {
    id: 'east_trading_post',
    color: 'yellow',
    cost: cost(''),
    effects: [{ kind: 'tradePrice', resources: ['wood', 'stone', 'clay', 'ore'], sides: ['right'] }],
    copies: copies(1, 3, 7),
  },
  {
    id: 'west_trading_post',
    color: 'yellow',
    cost: cost(''),
    effects: [{ kind: 'tradePrice', resources: ['wood', 'stone', 'clay', 'ore'], sides: ['left'] }],
    copies: copies(1, 3, 7),
  },
  {
    id: 'marketplace',
    color: 'yellow',
    cost: cost(''),
    effects: [{ kind: 'tradePrice', resources: ['glass', 'papyrus', 'textile'], sides: ['left', 'right'] }],
    copies: copies(1, 3, 6),
  },
  // Rojas
  { id: 'guard_tower', color: 'red', cost: cost('C'), effects: [shields(1)], copies: copies(1, 3, 4) },
  { id: 'barracks', color: 'red', cost: cost('O'), effects: [shields(1)], copies: copies(1, 3, 5) },
  { id: 'stockade', color: 'red', cost: cost('W'), effects: [shields(1)], copies: copies(1, 3, 7) },
  // Verdes
  { id: 'scriptorium', color: 'green', cost: cost('P'), effects: [science('tablet')], copies: copies(1, 3, 4) },
  { id: 'apothecary', color: 'green', cost: cost('L'), effects: [science('compass')], copies: copies(1, 3, 5) },
  { id: 'workshop', color: 'green', cost: cost('G'), effects: [science('gear')], copies: copies(1, 3, 7) },
];
